import { c as _c } from "react/compiler-runtime";
import React from 'react';
import isServer from 'commons/isServer';
import { createPortal } from 'react-dom';
import withBrowserOnly from 'components/hoc/withBrowserOnly';
import Login from './login';
import SignUp from './signup';
import GiftCard from './GiftCard';
import BagSaved from './BagSaved';
import PasswordReset from './PasswordReset';
import ForgotPassword from './forgotPassword';
import TradeQuotesBanner from './TradeQuotesBanner';
import LivestreamNotification from './LivestreamNotification';
import UserOrdersProtectionPlanBanner from './UserOrdersProtectionPlan';
import UserOrdersSubmitReviewPhotoBanner from './UserOrdersSubmitReviewPhoto';
import FabricFavoritedBanner from './FabricFavoritedBanner';
import { useNotificationState } from './utils';
const sidebarModalRootElement = !isServer() ? document.getElementById('SidebarModal-root') : null;
const NotificationBanner = () => {
  const $ = _c(45);
  const {
    type,
    props
  } = useNotificationState();
  if (isServer()) {
    return null;
  }
  let t0;
  if ($[0] !== props || $[1] !== type) {
    t0 = type === "login" && <Login {...props} />;
    $[0] = props;
    $[1] = type;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== props || $[4] !== type) {
    t1 = type === "signup" && <SignUp {...props} />;
    $[3] = props;
    $[4] = type;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== props || $[7] !== type) {
    t2 = type === "forgotPassword" && <ForgotPassword {...props} />;
    $[6] = props;
    $[7] = type;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== props || $[10] !== type) {
    t3 = type === "BagSaved" && <BagSaved {...props} />;
    $[9] = props;
    $[10] = type;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== props || $[13] !== type) {
    t4 = type === "GiftCard" && <GiftCard {...props} />;
    $[12] = props;
    $[13] = type;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== props || $[16] !== type) {
    t5 = type === "PasswordReset" && <PasswordReset {...props} />;
    $[15] = props;
    $[16] = type;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== props || $[19] !== type) {
    t6 = type === "TradeQuotesBanner" && <TradeQuotesBanner {...props} />;
    $[18] = props;
    $[19] = type;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== props || $[22] !== type) {
    t7 = type === "UserOrdersProtectionPlan" && <UserOrdersProtectionPlanBanner {...props} />;
    $[21] = props;
    $[22] = type;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== props || $[25] !== type) {
    t8 = type === "UserOrdersSubmitReviewPhoto" && <UserOrdersSubmitReviewPhotoBanner {...props} />;
    $[24] = props;
    $[25] = type;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] !== props || $[28] !== type) {
    t9 = type === "LivestreamNotification" && <LivestreamNotification {...props} />;
    $[27] = props;
    $[28] = type;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  let t10;
  if ($[30] !== props || $[31] !== type) {
    t10 = type === "FabricFavoritedBanner" && <FabricFavoritedBanner {...props} />;
    $[30] = props;
    $[31] = type;
    $[32] = t10;
  } else {
    t10 = $[32];
  }
  let t11;
  if ($[33] !== t0 || $[34] !== t1 || $[35] !== t10 || $[36] !== t2 || $[37] !== t3 || $[38] !== t4 || $[39] !== t5 || $[40] !== t6 || $[41] !== t7 || $[42] !== t8 || $[43] !== t9) {
    t11 = createPortal(<>{t0}{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}{t9}{t10}</>, sidebarModalRootElement);
    $[33] = t0;
    $[34] = t1;
    $[35] = t10;
    $[36] = t2;
    $[37] = t3;
    $[38] = t4;
    $[39] = t5;
    $[40] = t6;
    $[41] = t7;
    $[42] = t8;
    $[43] = t9;
    $[44] = t11;
  } else {
    t11 = $[44];
  }
  return t11;
};
export default withBrowserOnly(NotificationBanner);